import React, { useEffect, useRef } from 'react';
import '../styles/Footer.css';

const InstagramIcon = ({ size = 20 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <defs>
            <linearGradient id="igGrad" x1="0" x2="1">
                <stop offset="0%" stopColor="#f58529" />
                <stop offset="50%" stopColor="#dd2a7b" />
                <stop offset="100%" stopColor="#8134af" />
            </linearGradient>
        </defs>
        <rect x="2" y="2" width="20" height="20" rx="5" fill="url(#igGrad)" />
        <circle cx="12" cy="11.5" r="3.2" fill="#fff" />
        <circle cx="12" cy="11.5" r="2" fill="url(#igGrad)" />
        <circle cx="17.4" cy="6.6" r="0.9" fill="#fff" />
    </svg>
);

const YoutubeIcon = ({ size = 20 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <rect x="2" y="6" width="20" height="12" rx="3" fill="#FF0000" />
        <polygon points="10,9.5 15,12 10,14.5" fill="#fff" />
    </svg>
);

const Footer = () => {
    const footerRef = useRef(null);

    useEffect(() => {
        const setFooterHeight = () => {
            const el = footerRef.current;
            if (!el) return;
            const h = el.offsetHeight || el.getBoundingClientRect().height || 0;
            document.documentElement.style.setProperty('--footer-height', `${h}px`);
        };

        // Initial set
        setFooterHeight();

        // Update on resize (debounced via RAF)
        let rafId = null;
        const onResize = () => {
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(() => {
                setFooterHeight();
            });
        };

        window.addEventListener('resize', onResize);
        const observer = new ResizeObserver(() => setFooterHeight());
        if (footerRef.current) observer.observe(footerRef.current);

        // capture node reference for cleanup (avoids lint warning about ref mutation)
        const observedNode = footerRef.current;

        return () => {
            window.removeEventListener('resize', onResize);
            if (rafId) cancelAnimationFrame(rafId);
            if (observer && observedNode) observer.unobserve(observedNode);
        };
    }, []);

    return (
        <footer ref={footerRef} className="footer">
            <div className="footer-inner">
                <div className="footer-left">
                    <span>© {new Date().getFullYear()} Lignums Group. Todos los derechos reservados.</span>
                </div>

                {/* Términos y Condiciones desactivados (ver BITACORA.md, 2026-10-21). El contenedor
                    queda vacío para no correr el resto del pie. */}
                <div className="footer-center footer-links" />

                <div className="footer-right footer-social" aria-label="Redes sociales">
                    <a
                        className="social-link instagram"
                        href="https://www.instagram.com/lignumsgroup/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                    >
                        <InstagramIcon />
                        <span className="sr-only">Instagram</span>
                    </a>

                    <a
                        className="social-link youtube"
                        href="https://www.youtube.com/@LignumsGroup"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="YouTube"
                    >
                        <YoutubeIcon />
                        <span className="sr-only">YouTube</span>
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
